module.exports = __webpack_public_path__ + "static/img/ncm.011bd60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ncm.png
// module id = Q0fC
// module chunks = 1